import { clearAuthCookies } from 'modules/authentication/helpers/cookies';
import { unstable_batchedUpdates } from 'react-dom';
import useAuthStore from '~/authentication/store';

export const signOut = async (callbackUrl: string): Promise<void> => {
  try {
    const params = new URLSearchParams();
    params.set('callbackUrl', callbackUrl);
    params.set('json', 'true');

    const signoutResponse = await fetch(
      `${URL_AUTHENTICATION_HOST}/api/auth/signout`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        credentials: 'include',
        body: params.toString(),
      },
    );

    await clearAuthCookies();

    void (await signoutResponse.json());
    unstable_batchedUpdates(() => {
      useAuthStore.getState().logout();
    });
    window.location.href = '/';
  } catch (exception) {
    console.error('Error signing out', exception);
  }
};
